import { TGetOrderResponse } from '@p2p/services';
import { PaymentType } from '@p2p/shared/constants';

export const UZBEKISTAN_BANKS = [
  'Asia Alliance Bank (Узбекистан)',
  'Garant Bank (Узбекистан)',
  'Octobank (Узбекистан)',
  'Poytaxt Bank (Узбекистан)',
];

export const isSberUzbekistan = (order: TGetOrderResponse) => {
  if (order.client_bank_code !== 'sber') {
    return false;
  }

  if (!UZBEKISTAN_BANKS.includes(order.requisite.bank.name)) {
    return false;
  }

  const paymentType = order.requisite.payment_type as PaymentType;

  if (PaymentType.PAYMENT_TYPE_SBP !== paymentType) {
    return false;
  }

  return true;
};
